import Vue from "vue";
import router from "../../router";

//set Headers payload
const authHeader = process.env.VUE_APP_REQUEST_HEADER;
const headers = {};
headers[authHeader] = process.env.VUE_APP_HUB_API_KEY;

export default {
    namespaced: true,
    state: () => ({
      isSalesLeadsSearchList: false,
      loadingSalesLeads: false,
      salesLeads: [],
      loadingSingleSalesLeand: false,
      singleSalesLead: {},
      loadingLeadCheck: false,
      loadingAddLead: false,
      loadingLeadActions: false,
      interestOptions: [
          { text: 'Nu', value: 'red', color: 'red' },
          { text: 'Ocazional', value: 'orange', color: 'orange' },
          { text: 'Da, potential bun', value: 'blue', color: 'blue' },
          { text: 'Da, șanse mari să începem colaborarea, are consum important pe aluminiu', value: 'green', color: 'green' }
      ],
      pendingReasons: [
        {
          text: "se asteapta raspuns de la beneficiarul final",
          value: "se asteapta raspuns de la beneficiarul final",
        },
        {
          text: "se doreste un pret mai bun",
          value: "se doreste un pret mai bun"
        }
      ],
      rejectMotives: [
          {
              text: "nu are buget",
              value: "nu are buget",
          },
          {
              text: "amana decizia",
              value: "amana decizia",
          },
          {
              text: "solicita oferta pentru comparatie",
              value: "solicita oferta pentru comparatie",
          },
          {
              text: "persoana de decizia nu a fost implicata",
              value: "persoana de decizia nu a fost implicata",
          },
          {
              text: "se doreste o solutie mai ieftina",
              value: "se doreste o solutie mai ieftina",
          },
          {
              text: "termenul de livrare este prea lung",
              value: "termenul de livrare este prea lung",
          },
          {
            text: "lucreaza numai cu termen de plata",
            value: "lucreaza numai cu termen de plata"
          }
      ],
      turnoverOptions: [
          {
              text: "0 - 1.000.000",
              value: 1000000,
          },
          {
              text: "1.000.000 - 1.500.000",
              value: 1500000,
          },
          {
              text: "1.500.000 - 5.000.000",
              value: 5000000,
          },
          {
              text: "5.000.000 - 10.000.000",
              value: 10000000,
          },
          {
              text: "Peste 10.000.000",
              value: 10000001,
          }
      ],
      profitOptions: [
          {
              text: "pierdere",
              value: 0
          },
          {
              text: "0 - 100.000",
              value: 100000,
          },
          {
              text: "100.000 - 500.000",
              value: 500000,
          },
          {
              text: "500.000 - 1.000.000",
              value: 1000000,
          },
          {
              text: "1.000.000 - 5.000.000",
              value: 5000000,
          },
          {
              text: "Peste 5.000.000",
              value: 5000001,
          }
      ],
      activityFields: [
          { text: "Comert", value: "comert" },
          { text: "Servicii", value: "servicii" },
          { text: "Industrie", value: "industrie" },
          { text: "Constructii", value: "constructii" },
          { text: "Altele", value: "altele" }
      ],
      employeeOptions: [
          {
              text: "1 - 10",
              value: 10,
          },
          {
              text: "10 - 20",
              value: 20,
          },
          {
              text: "20 - 50",
              value: 50,
          },
          {
              text: "50 - 200",
              value: 200,
          },
          {
              text: "Peste 200",
              value: 201,
          }
      ],
      actionTypes: [
        {
          text: 'Sunat',
          value: 'call'
        }
      ]
    }),
    mutations: {
      setLoadingSalesLeads(state, item) {
        state.loadingSalesLeads = item
      },
      setLoadingSingleSalesLead(state, item) {
        state.loadingSingleSalesLeand = item
      },
      setLoadingLeadCheck(state, item) {
        state.loadingLeadCheck = item
      },
      setLoadingAddLead(state, item) {
        state.loadingAddLead = item
      },
      setLoadingLeadActions(state, item) {
        state.loadingLeadActions = item
      },
      loadSalesLeads(state, items) {
        state.salesLeads = items;
      },
      loadSingleSalesLead(state, item) {
        if (item.client_details) {
          item.client_details = JSON.parse(item.client_details);
        }
        if (item.extra_details) {
          item.extra_details = JSON.parse(item.extra_details);
        }
        if (item.products) {
          item.products = JSON.parse(item.products);
        }
        state.singleSalesLead = item
      },
      addLead(state, item) {
        state.salesLeads.push(item);
      },
      updateLeadCalledStatus(state, payload) {
        const lead = state.salesLeads.find(lead => lead.id === payload.id);
        if (lead) {
          lead.called = payload.called;
          lead.called_user_id = payload.user_id;
          lead.called_user = payload.username;
          lead.called_date = payload.called == 0 ? null : new Date().toISOString();
        }
      },
      updateLeadRejectReason(state, payload) {
        const lead = state.salesLeads.find(lead => lead.id === payload.id);
        if (lead) {
          lead.reject_reason = payload.reason;
        }
      },
      updateLeadInterestStatus(state, payload) {
        const lead = state.salesLeads.find(lead => lead.id === payload.id);
        if (lead) {
          lead.interest = payload.interest;
        }
      },
    },
    actions: {
      async checkLeadCui({ commit } , cui) {
        commit("setLoadingLeadCheck", true);
        let url = process.env.VUE_APP_HUB_API_HOST + "api/sales-leads/check/cui";

        const urlParams = {
          cui: cui,
        };

        try {
          const response = await Vue.http.get(url, {
            headers: headers,
            params: urlParams
          });
          commit("setLoadingLeadCheck", false);
          return response.data;
        } catch (error) {
          console.log(error);
          commit("setLoadingLeadCheck", false);
          return null;
        }
      },
      fetchSalesLeads({ commit, rootGetters }) {
        commit("setLoadingSalesLeads", true);
        const user = rootGetters.loggedUser;

        let url = process.env.VUE_APP_HUB_API_HOST + "api/sales-leads";

        if (["agent"].includes(user.rol) && user.departament == 'vanzari') {
          url += "/" + user.id_user
        }

        Vue.http.get(url, {
          headers: headers,
        })
        .then(response => {
          commit("loadSalesLeads", response.data);
          commit("setLoadingSalesLeads", false);
        })
        .catch(error => {
          console.log(error);
          commit("setLoadingSalesLeads", false);
        });
      },
      async addLead({ commit }, lead ) {
        commit("setLoadingAddLead", true);
        let url = process.env.VUE_APP_HUB_API_HOST + "api/sales-leads/add";
        try {
          const response = await Vue.http.post(url, lead, {
            headers: headers
          });
          lead.id = response.body.id;
          lead.created_at = response.body.created_at;
          lead.nume = lead.name;
          lead.username = lead.userName;
          lead.id_user = lead.userId
          lead.called = "0"
          lead.called_user_id = null
          lead.called_user = null
          lead.called_date = null
          lead.interest = null
          commit("addLead", lead);
          commit("setLoadingAddLead", false);
          router.push({ query: M.toast( { html: response.body.message, classes: "bg-green-500" }) });
        } catch (error) {
          console.log(error);
          commit("setLoadingAddLead", false);
        }
      },
      markCalledLeadSales({ commit }, payload ) {
        let url = process.env.VUE_APP_HUB_API_HOST + "api/sales-leads/mark-called"

        Vue.http.put(url, payload, {
          headers: headers
        }).then(response => {
          commit('updateLeadCalledStatus', payload);
          M.toast({ html: response.body, classes: "bg-green-500" });
        }).catch(error => {
          console.log(error);
          M.toast({ html: "Eroare!", classes: "bg-red-500" });
        })
      },
      changeLeadRejectReason({ commit }, payload) {
        let url = process.env.VUE_APP_HUB_API_HOST + "api/sales-leads/change-reject-reason";

        Vue.http.put(url, payload, {
          headers: headers
        })
        .then(response => {
          commit('updateLeadRejectReason', payload);
          M.toast({ html: response.body, classes: "bg-green-500" });
        })
        .catch(error => {
          console.log(error);
          M.toast({ html: "Eroare!", classes: "bg-red-500" });
        });
      },
      changeLeadInterestStatus({ commit }, payload) {
        let url = process.env.VUE_APP_HUB_API_HOST + "api/sales-leads/change-interest-status";

        Vue.http.put(url, payload, {
          headers: headers
        })
        .then(response => {
          commit('updateLeadInterestStatus', payload);
          M.toast({ html: response.body, classes: "bg-green-500" });
        })
        .catch(error => {
          console.log(error);
          M.toast({ html: "Eroare!", classes: "bg-red-500" });
        });
      },
      // Leads Actions
      async fetchSalesLeadsActions({ commit }, leadId) {
        commit("setLoadingLeadActions", true);
        const url = process.env.VUE_APP_HUB_API_HOST + "api/sales-leads/" + leadId + "/actions";

         try {
           const res = await Vue.http.get(url, { headers: headers })
           return res.data
         } catch (error) {
            console.log(error);
         }
      },
      async addLeadAction(context, payload) {
        const url = process.env.VUE_APP_HUB_API_HOST + "api/sales-leads/actions";
        try {
          const response = await Vue.http.post(url, payload, {
            headers: headers
          });
          router.push({ query: M.toast( { html: response.body.message, classes: "bg-green-500" }) });
        } catch (error) {
          console.log(error);
        }

      },
    }
}